import { CloseOutlined } from "@ant-design/icons";
import { Button, Input, Modal, Select, Tooltip } from "antd";
import Cookies from "js-cookie";
import { orderCancellationRemark } from "modules/navbar/top/helper";
import React, { useState, useEffect } from "react";
import { useOrderCancellation } from "./store";
import { useToast } from "modules/navbar/top/store/toasterStore";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import secureLocalStorage from "react-secure-storage";


const CancelOrder = ({
  currentId,
  isDisabled, // Corrected the typo in prop name
  buttonText,
}) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedRemark, setSelectedRemark] = useState(null);
  const [comment, setComment] = useState("");
  const [email, setEmail] = useState("");
  const { cancelOrderData, fetchOrderCancellation } = useOrderCancellation();
  const { setToaster } = useToast();

  const handleCancelOrder = () => {
    setIsModalVisible(true);
  };

  const handleRemarkChange = (selectedOption) => {
    setSelectedRemark(selectedOption);
  };

  const handleCommentChange = (e) => {
    setComment(e.target.value);
  };

  const handleCancelConfirmation = async () => {
    setIsModalVisible(false);
    const payload = {
      order_display_id: currentId,
      category: "order_related",
      subcategory: "auto_order_cancellation_initiated",
      remark: selectedRemark,
      comment: comment,
    };
    await fetchOrderCancellation(payload, toast);
  };

  useEffect(() => {
    setEmail(secureLocalStorage.getItem("email"));
  }, []);

  return (
    <div>
      <Tooltip title="Cancel Order">
        <div onClick={handleCancelOrder}>
          <span
            className={`mt-n1 bg-${
              isDisabled ? "secondary" : "danger"
            } text-white p-2 rounded-circle d-flex justify-content-center align-items-center shadow`}
            id="cancelId"
          >
            {buttonText}
          </span>
        </div>
      </Tooltip>
      <Modal
        title="Cancel Order"
        visible={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        footer={[
          <Button
            key="cancel"
            onClick={() => !isDisabled && setIsModalVisible(false)}
          >
            Cancel
          </Button>,
          <Button
            key="submit"
            type="primary"
            onClick={handleCancelConfirmation}
            disabled={!selectedRemark}
          >
            Confirm Cancellation
          </Button>,
        ]}
      >
        <div>
          <div>
            <strong>Order ID:</strong> {currentId}
          </div>
          <div>
            <strong>Category:</strong> Order Related
          </div>
          <div>
            <strong>Subcategory:</strong> Auto Order Cancellation Initiated
          </div>
          <div>
            <label>Remark:</label>
            <Select
              options={orderCancellationRemark}
              value={selectedRemark}
              onChange={handleRemarkChange}
              style={{ width: "100%" }}
              placeholder="Select a remark"
            />
          </div>
          <div style={{ marginTop: "1rem" }}>
            <label>Comment:</label>
            <Input.TextArea
              value={comment}
              onChange={handleCommentChange}
              placeholder="Enter your comments here"
              rows={4}
            />
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default CancelOrder;
